import React, { useState } from "react";
import Modal from "react-modal";
import "./PopUpExcludedAccount.scss";
import { ReactComponent as Arrow } from "./../../../assets/svg/arrow.svg";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { useAuthValidation } from "../../../hooks/useAuthValidation"; // Importa o hook do contexto
import api from "../../../services/api";

Modal.setAppElement("#root");

function PopUpExcludedAccount({ isOpen, closeModal }) {
  const { t } = useTranslation();
  const { user, loading } = useAuthValidation(); // Obtém o usuário e o estado de carregamento do contexto
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  if (loading) {
    return <div className="loading">{t("loading")}</div>; // Exibe um carregamento enquanto o contexto está carregando
  }

  if (!user) {
    return null; // Não renderiza o modal se o usuário não estiver autenticado
  }

  const handleSubmit = async () => {
    try {
      await api.post("/user/delete-account");
      // Sucesso ao deletar a conta
      localStorage.removeItem("token"); // Remove o token do localStorage
      localStorage.removeItem("typeUser"); // Remove o tipo de usuário, se aplicável
      navigate("/"); // Redireciona para a página inicial
    } catch (error) {
      console.error("Erro ao excluir a conta:", error);
      setError(t("error-deleting-account"));
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      contentLabel={t("exclude-account-modal")}
      className="excluded-account"
    >
      <button onClick={closeModal} className="row link">
        <Arrow />
        {t("go-back")}
      </button>
      <div>
        <h2>{t("pop-up-excluded-account")}</h2>
        <span>{t("pop-up-excluded-account-text")}</span>
        {error && <p className="error">{error}</p>}
        <button className="button" onClick={handleSubmit}>
          {t("pop-up-excluded-account-button")}
        </button>
      </div>
    </Modal>
  );
}

export default PopUpExcludedAccount;
